export default __webpack_public_path__ + "static/spiritual-maya-activity-1-101deec5e859ef6513e5814d5d63d667.jpg";